const editGroupAnnouncementRoute = ({ groupId, id }) =>
  `/management_panel/groups_management/${groupId}/announcements/${id}/edit`

const newGroupAnnouncementRoute = ({ groupId }) =>
  `/management_panel/groups_management/${groupId}/announcements/new`

export { editGroupAnnouncementRoute, newGroupAnnouncementRoute }
